export default __webpack_public_path__ + "static/media/send-icon.d3db155d.svg";